var React = require('react');

function IconViewlist (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M433.2 211.7l68.9-68.9v738.1L433.2 812h527.2l-68.9 68.9V142.8l68.9 68.9H433.2zm527.2-58.9v718.1c0 5.5-4.5 10-10 10H443.2c-5.5 0-10-4.5-10-10V152.8c0-5.5 4.5-10 10-10h507.2c5.5 0 10 4.5 10 10zm-886.3-10h296.3c5.5 0 10 4.5 10 10v85.4c0 5.5-4.5 10-10 10H74.1c-5.5 0-10-4.5-10-10v-85.4c0-5.5 4.5-10 10-10zm0 210.9h296.3c5.5 0 10 4.5 10 10v85.4c0 5.5-4.5 10-10 10H74.1c-5.5 0-10-4.5-10-10v-85.4c0-5.5 4.5-10 10-10zm0 210.8h296.3c5.5 0 10 4.5 10 10V660c0 5.5-4.5 10-10 10H74.1c-5.5 0-10-4.5-10-10v-85.5c0-5.5 4.5-10 10-10zm0 210.9h296.3c5.5 0 10 4.5 10 10v85.4c0 5.5-4.5 10-10 10H74.1c-5.5 0-10-4.5-10-10v-85.4c0-5.5 4.5-10 10-10z"}));
}

IconViewlist.displayName = "IconViewlist";

IconViewlist.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconViewlist;

IconViewlist.default = IconViewlist;
